import type { FunctionComponent } from "react"

import { TeamsJobPositions } from "@/modules/companies/client/components/TeamsJobPositions/TeamsJobPositions"
import { TeamsPresentation } from "@/modules/companies/client/components/TeamsPresentation/TeamsPresentation"
import { TeamsTitle } from "@/modules/companies/client/components/TeamsTitle/TeamsTitle"

export const TeamsWrapper: FunctionComponent = () => (
  <>
    <TeamsTitle />
    <TeamsPresentation />
    <TeamsJobPositions />
  </>
)
